import 'ui-core/widgets/publication-content/js/publication-content';

function authorInfoController() {
    const authorContainers = $('.loa-wrapper .accordion-tabbed__tab-mobile, ul.loa.mobile-authors li');
    const authorInfoContent = $('.accordion-tabbed__content');

    function showAuthorInfo(e) {
        e.stopPropagation();
        e.preventDefault();
        const authorInfo = $(this).find('.author-info');
        $('.author-info').not(authorInfo).hide();
        authorInfo.toggle();
    }

    function hideAauthorsInfo() {
        $('.author-info').hide();
    }

    authorContainers.on('click', showAuthorInfo);
    authorInfoContent.on('click', e => e.stopPropagation());
    $(document).on('click', hideAauthorsInfo);
}
UX.loader.showTable = function (id) {
    const target = $('#' + id);
    const tables = $('.tableWrapper');
    tables.addClass('visuallyhidden');
    const len = tables.length;
    let index = -1;
    let nextTarget, prevTarget;
    for (let i = 0; i < len; i++) {
        if (tables[i].id === id) index = i;
        if (index - 1 >= 0) prevTarget = "'" + tables[index - 1].id + "'";
        if (index + 1 < len) nextTarget = "'" + tables[index + 1].id + "'";
    }
    const hideParam = "'" + id + "'";
    const nLink =
        index + 1 < len
            ? '<a class="next" title="Next Table" href="javascript:void(0)" onclick="UX.loader.showTable(' +
              nextTarget +
              ')"></a>'
            : '';
    const pLink =
        index - 1 > -1
            ? '<a class="prev" title="Previous Table" href="javascript:void(0)" onclick="UX.loader.showTable(' +
              prevTarget +
              ')"></a>'
            : '';
    const navigator =
        '<a title="Close Table Viewer" id="tableCloseButton" href="#" onclick="UX.loader.hideTable(' +
        hideParam +
        '); return false;" class="close"></a>\
                        <div class="tableNav">\
                            ' +
        pLink +
        '\
                            <span id="NavText">Table <span class="index">' +
        (index + 1) +
        '</span> of ' +
        len +
        '</span>\
                            ' +
        nLink +
        '\
                        </div>';
    $('.tableViewerNav', target).html(navigator);
    target.find('#tableCloseButton').css({right: 10 - target.scrollLeft()});
    target.removeClass('visuallyhidden');
};
UX.loader.hideTable = function (id) {
    $('.tableWrapper').addClass('visuallyhidden');
};
UX.loader.additionalController = function () {
    $(document).on('click', '.showTableEvent', function (e) {
        e.preventDefault();
        const ID = $(e.target).closest('a').attr('data-id');
        UX.loader.showTable('div-' + ID + '');
    });

    $('.showTableEEvent').click(function (e) {
        e.preventDefault();
        const ID = $('.showtable_wrap a.showTableEvent').attr('data-id');
        UX.loader.showTable('div-' + ID + '');
    });
    $('.tableWrapper').scroll(function (e) {
        $(this)
            .find('#tableCloseButton')
            .css({right: 10 - $(this).scrollLeft()});
    });

    $(document).mouseup(function (e) {
        const tableWrapper = $('.tableWrapper');
        if (!tableWrapper.is(e.target) && tableWrapper.has(e.target).length === 0) {
            tableWrapper.addClass('visuallyhidden');
        }
    });
    window.addEventListener('load', UX.loader.setCoolbarHeight);
    authorInfoController();
};

UX.loader.setCoolbarHeight = function () {
    const counter = document.getElementById('sectionMenu');
    const rectTop = counter.getBoundingClientRect().top;
    const wih = window.innerHeight;
    const bottomMargin = 0.1 * wih;
    const maxHeight = rectTop * 2 > wih ? wih - rectTop - bottomMargin : wih / 2;
    counter.style.maxHeight = maxHeight + 'px';
};
